@if (transactionsList?.length) {
  <section class="my-2">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="custom-wallet">
              <div class="custom-wallet-input-wrapper">
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.5 0.375C6.69898 0.375 0.375 6.69898 0.375 14.5C0.375 22.301 6.69898 28.625 14.5 28.625C22.301 28.625 28.625 22.301 28.625 14.5C28.625 6.69898 22.301 0.375 14.5 0.375ZM2.375 14.5C2.375 7.80355 7.80355 2.375 14.5 2.375C21.1965 2.375 26.625 7.80355 26.625 14.5C26.625 21.1965 21.1965 26.625 14.5 26.625C7.80355 26.625 2.375 21.1965 2.375 14.5ZM15.5 8.66667C15.5 8.11438 15.0523 7.66667 14.5 7.66667C13.9477 7.66667 13.5 8.11438 13.5 8.66667V14.5C13.5 14.8344 13.6671 15.1466 13.9453 15.3321L18.3203 18.2487C18.7798 18.5551 19.4007 18.4309 19.7071 17.9714C20.0134 17.5118 19.8892 16.891 19.4297 16.5846L15.5 13.9648V8.66667Z"
                    fill="#679EC6"
                  />
                </svg>
                <p
                  class="custom-wallet-input py-0 d-inline-block ms-2 text-uppercase"
                >
                  LATEST TRANSACTIONS
                </p>
              </div>
            </div>
            <div>
              @for (item of transactionsList; track item) {
                <div class="transaction-wrap d-flex align-items-center mb-3">
                  <div class="d-flex align-items-center h-100">
                    @if (item.operation === "DEBIT") {
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 35 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="17.5"
                          cy="17.5"
                          r="17.5"
                          transform="rotate(-180 17.5 17.5)"
                          fill="#EB1F39"
                        />
                        <path
                          d="M18.2288 23.3337L18.2288 14.4597L22.3049 18.5357L23.333 17.5003L17.4997 11.667L11.6663 17.5003L12.6945 18.5284L16.7705 14.4597L16.7705 23.3337L18.2288 23.3337Z"
                          fill="white"
                        />
                      </svg>
                    }
                    @if (item.operation === "CREDIT") {
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 35 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="17.5" cy="17.5" r="17.5" fill="#41BE06" />
                        <path
                          d="M16.7712 11.6663L16.7712 20.5403L12.6951 16.4643L11.667 17.4997L17.5003 23.333L23.3337 17.4997L22.3055 16.4715L18.2295 20.5403L18.2295 11.6663L16.7712 11.6663Z"
                          fill="white"
                        />
                      </svg>
                    }
                    @if (item.operation === "EXCHANGE") {
                      <ng-container class="mt-4">
                        <img
                          src="/assets/media/icons/exchange-icon.svg"
                          alt="exchange icon"
                        />
                      </ng-container>
                    }
                  </div>
                  <div style="overflow: hidden">
                    <p class="tran-type-details mb-0">
                      @if (isCurrencyConversionTransaction(item)) {
                        <span>
                          Converted {{ item.converted_from }} to
                          {{ item.currency }} -
                          {{ getReferenceDetails(item) }}
                        </span>
                      }
                      @if (isPrepaidTransaction(item)) {
                        <span>
                          Payment {{ getPaymentDirection(item) }}
                          {{ getPrepaidReference(item) }} -
                          {{ getReferenceDetails(item) }}
                        </span>
                      }
                      @if (
                        !isPrepaidTransaction(item) &&
                        !isGetPaid(item) &&
                        !isPrepaidBooking(item) &&
                        !isTazaPay(item) &&
                        !isCurrencyConversionTransaction(item)
                      ) {
                        <span>
                          {{ getTazaPayPayment(item) }}
                          {{ GetPaidReferenceValue(item) }}
                          {{ item.tran_type }} :
                          {{ getReferenceDetails(item) }}
                        </span>
                      }
                      @if (isPrepaidBooking(item)) {
                        <span>
                          {{ item.tran_type }} - AWB :
                          {{ BookingReferenceType(item) }}
                        </span>
                      }
                      @if (isGetPaid(item) || isTazaPay(item)) {
                        <span>
                          {{ getTazaPayPayment(item) }}
                          {{ GetPaidReferenceValue(item) }} -
                          {{ getReferenceDetails(item) }}
                        </span>
                      }
                    </p>
                    <span class="wallet-currency font-weight-500"
                      ><span
                        class="font-weight-bold wallet-set-currency currency-symbol"
                        >{{ getCurrencySymbol(item.currency) }}</span
                      >
                      <span class="font-weight-bold wallet-set-currency"
                        >{{
                          item.balance_movement?.toString().split(".")[0]
                            | caiNumberFormatter: false : 0 : true
                        }}.{{
                          (
                            item.balance_movement?.toString().split(".")[1] ??
                            "00"
                          ).padEnd(2, "0")
                        }}</span
                      >
                    </span>
                    <span class="transaction-date">{{
                      item.started_at | date: "MM/dd/yyyy"
                    }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}
